<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, computed } from 'vue';
import UtilMoney from '@/utils/UtilMoney.js';

/*==================================================================*/
/*================== IMPORTS DE COMPONENTES ========================*/
/*==================================================================*/

import CartaoBase from '@/components/v2/base/CartaoBase/CartaoBase.vue';
import ChipBase from '@/components/v2/base/ChipBase/ChipBase.vue';
import CampoTextoBase from '@/components/v2/base/CampoTextoBase/CampoTextoBase.vue';
import CampoDataBase from '@/components/v2/base/CampoDataBase/CampoDataBase.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({

    dado: {
        type: Object,
        default: () => ({})
    }

});

/*==================================================================*/
/*================== CREDOR ========================================*/
/*==================================================================*/

const credor = computed(() => {

    if (props.dado?.tipoCredor === 'Fornecedor') {
        return props.dado?.credorFornecedor?.nomeFantasia ?? "";
    }

    return props.dado?.credorColaborador?.nome ?? "";

});

/*==================================================================*/
/*=========== Mostra Data de Previsão de Pagamento =================*/
/*==================================================================*/

const mostraDataPrevisaoDePagamento = computed(()=>{

    // Se for Diferente de Boleto
    if(props?.dado?.formaDePagamento != "Boleto") {
        return false;
    }

    return true;

});

</script>

<template>

    <CartaoBase>

        <template #header>

            <div class="c-header">

                <span class="c-header__titulo">Ordem de Pagamento - {{props?.dado?.numero}}</span>

                <ChipBase
                    class="c-header__campo_valor"
                    backgroundColor="#4CAF50"
                    textColor="#ffffff"
                >
                    {{ `Valor da Ordem de Pagamento: ${ UtilMoney.toR$BRL(props?.dado?.valorTotal) }` }}
                </ChipBase>

            </div>

        </template>

        <template #body>

            <div class="c-grid">

                <CampoTextoBase
                    label="Status"
                    :value="props?.dado?.status"
                    disabled
                ></CampoTextoBase>

                <CampoTextoBase
                    label="Emitente"
                    :value="props?.dado?.emitente?.nome"
                    disabled
                ></CampoTextoBase>

                <CampoTextoBase
                    label="Requisitante"
                    :value="props?.dado?.requisitante?.nome"
                    disabled
                ></CampoTextoBase>

                <CampoTextoBase
                    label="Tipo"
                    :value="props?.dado?.tipo"
                    disabled
                ></CampoTextoBase>

                <CampoTextoBase
                    label="Tipo de Credor"
                    :value="props?.dado?.tipoCredor"
                    disabled
                ></CampoTextoBase>

                <CampoTextoBase
                    label="Credor"
                    :value="credor"
                    disabled
                ></CampoTextoBase>

                <CampoTextoBase
                    label="Forma de Pagamento"
                    :value="props?.dado?.formaDePagamento"
                    disabled
                ></CampoTextoBase>

                <CampoDataBase
                    label="Data de Criação"
                    :value="props?.dado?.dataCriacao"
                    disabled
                ></CampoDataBase>

                <CampoDataBase
                    v-show="mostraDataPrevisaoDePagamento"
                    label="Data de Previsão de Pagamento"
                    :value="props?.dado?.dataPrevisaoPagamento"
                    disabled
                ></CampoDataBase>

                <CampoTextoBase
                    label="Nota Fiscal"
                    :value="props?.dado?.notaFiscal"
                    disabled
                    class="campo-nota-fiscal"
                ></CampoTextoBase>

            </div>

        </template>

    </CartaoBase>

</template>

<style scoped>

/*==================================================================*/
/*================== Header ========================================*/
/*==================================================================*/

.c-header {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-rows: max-content;
    grid-template-areas:
        "titulo valor";
    gap: 16px;
}

.c-header__titulo {
    grid-area: titulo;
    font-size: 1.25rem;
    font-weight: 700;
}

.c-header__campo_valor {
    grid-area: valor;
}

@media(max-width: 768px){

    .c-header {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: max-content;
        grid-template-areas:
            "titulo"
            "valor";
        gap: 16px;
    }

}

/*==================================================================*/
/*================== Grid ==========================================*/
/*==================================================================*/

.c-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
}

/*==================================================================*/
/*================== Nota Fiscal ocupa 3 colunas ===================*/
/*==================================================================*/

.campo-nota-fiscal {
    grid-column: span 3;
}

@media (max-width: 768px) {

    .c-grid {
        display: grid;
        grid-template-columns: 1fr;
        grid-auto-rows: max-content;
    }

    .campo-nota-fiscal {
        grid-column: span 1;
    }

}

</style>
